module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAPCAYAAACBdR0qAAAAeElEQVR4AWO4ryZzHoj/DzDuZwAzBh7vhzuEgf4AZLfDEHIIQqEAAcMMgFiBgBoFkDpyHAISL4ArIuyj93jUCIDkoeoMyHFIA1TuPh5LApASnADO0ECocSDHIQIgiwgFO1SNARFpIWDoJ1YEGHXIqEMGvq4ZNLUvAMe/v8FGhQ2bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/key-rack-icon.png
// module id = 479
// module chunks = 0